export const userConstants = {
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  UPLOAD_MEDIA_REQUEST: 'UPLOAD_MEDIA__REQUEST',
  UPLOAD_MEDIA__SUCCESS: 'UPLOAD_MEDIA__SUCCESS',
  UPLOAD_MEDIA__FAILURE: 'UPLOAD_MEDIA__FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  VALIDATEOTP_REQUEST: 'USERS_LOGIN_REQUEST',
  VALIDATEOTP_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT: 'USERS_LOGOUT',
  CLEAR_PWD_MESSAGE: 'CLEAR_PWD_MESSAGE',
  CLEAR_RESET_PWD_MSG: 'CLEAR_RESET_PWD_MSG',
  RESET_AUTHENTICATION: 'RESET_AUTHENTICATION',

  GETALL_REQUEST: 'USERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'USERS_GETALL_FAILURE',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',

  CUSTOMER_REQUEST: 'USERS_CUSTOMER_REQUEST',
  CUSTOMER_SUCCESS: 'USERS_CUSTOMER_SUCCESS',
  CUSTOMER_FAILURE: 'USERS_CUSTOMER_FAILURE',

  FORGOTPIN_REQUEST: 'USERS_FORGOTPIN_REQUEST',
  FORGOTPIN_SUCCESS: 'USERS_FORGOTPIN_SUCCESS',
  FORGOTPIN_FAILURE: 'USERS_FORGOTPIN_FAILURE',
  RESET_MSG: 'RESET_MSG',

  FORGOTPASS_REQUEST: 'USERS_FORGOTPASS_REQUEST',
  FORGOTPASS_SUCCESS: 'USERS_FORGOTPASS_SUCCESS',
  FORGOTPASS_FAILURE: 'USERS_FORGOTPASS_FAILURE',

  CHANGEPASS_REQUEST: 'USERS_CHANGEPASS_REQUEST',
  CHANGEPASS_SUCCESS: 'USERS_CHANGEPASS_SUCCESS',
  CHANGEPASS_FAILURE: 'USERS_CHANGEPASS_FAILURE',

  RESETPIN_REQUEST: 'USERS_RESETPIN_REQUEST',
  RESETPIN_SUCCESS: 'USERS_RESETPIN_SUCCESS',
  RESETPIN_FAILURE: 'USERS_RESETPIN_FAILURE',

  RESETPASS_REQUEST: 'USERS_RESETPASS_REQUEST',
  RESETPASS_SUCCESS: 'USERS_RESETPASS_SUCCESS',
  RESETPASS_FAILURE: 'USERS_RESETPASS_FAILURE',

  VERIFYOTP_REQUEST: 'USERS_VERIFYOTP_REQUEST',
  VERIFYOTP_SUCCESS: 'USERS_VERIFYOTP_SUCCESS',
  VERIFYOTP_FAILURE: 'USERS_VERIFYOTP_FAILURE',

  GENERATEOTP_REQUEST: 'USERS_GENERATEOTP_REQUEST',
  GENERATEOTP_SUCCESS: 'USERS_GENERATEOTP_SUCCESS',
  GENERATEOTP_FAILURE: 'USERS_GENERATEOTP_FAILURE',

  SETCREDENTAIL_REQUEST: 'USERS_SETCREDENTAIL_REQUEST',
  SETCREDENTAIL_SUCCESS: 'USERS_SETCREDENTAIL_SUCCESS',
  SETCREDENTAIL_FAILURE: 'USERS_SETCREDENTAIL_FAILURE',

  ABOUTUS_REQUEST: 'USERS_ABOUTUS_REQUEST',
  ABOUTUS_SUCCESS: 'USERS_ABOUTUS_SUCCESS',
  ABOUTUS_FAILURE: 'USERS_ABOUTUS_FAILURE',

  GET_ID_TYPE_REQUEST: 'GET_ID_TYPE_REQUEST',
  GET_ID_TYPE_SUCCESS: 'GET_ID_TYPE_SUCCESS',
  GET_ID_TYPE_FAILURE: 'GET_ID_TYPE_FAILURE',

  GET_PROFESSION_REQUEST: 'GET_PROFESSION_REQUEST',
  GET_PROFESSION_SUCCESS: 'GET_PROFESSION_SUCCESS',
  GET_PROFESSION_FAILURE: 'GET_PROFESSION_FAILURE',
};
